import React, { useEffect, useRef } from 'react'
import { BrowserRouter, Routes, Route, useLocation, useParams, useNavigate, Navigate, Outlet } from "react-router-dom";
import Navbar from './Navbar/page'
import Footer from './footer/page'
import Homepage from './Home/page'
import Triviafun from "./Triviafun/page";
import Instruction from './Instruction/page'
import Privacy from './Privacy/page'
import TermCondition from './TermandCondition/page'
import Login from './Auth/login'
import Forgot from './Auth/Forgot'
import VerifyOTP from './Auth/VerifyOTP'
import Resetpassword from './Auth/Resetpassword'
import ProfilePage from './Profile/Profilesection'
import GameArea from './GamingArea/page'
import LevelOne from './GamingArea/LevelOne'
import LevelTwo from './GamingArea/LevelTwo';
import ResultPage from './GamingArea/Scorepage'
import GameoverPage from './GamingArea/GameOver'
import Wallet from './Wallet/page'
import Transact from './transactionHistory/page'
import Rewards from './Rewards/page'
import Leaderboader from './Leaderboard/page'
import Demoresult from './DemoGameSection/gamesection/score/page'
import DemoGame from './DemoGameSection/gamesection/page'
import LeaderScore from './Leaderboard/LeaderScore/Page'
import GamesList from './GamesList/Page'
import RefLink from './RefLink/RefLink';
import DemoLeaderboard from './DemoLeaderboard/DemoLeaderboard';
import Sidenavar from './Navbar/sideNav/page';
import Header from './Navbar/page';
import LandingPage from './landingPage/LandingPage';
import MainRoutes from './MainRoutes';
import SponsorPage from './RefLink/SponsorPage';
// import RefLink from './ReferralLink/RefLink';
// import Referal from './ReferralLink/Referal';

function Router() {
    // const location = useLocation();
    // console.log("location",location)
    // const ProtectedRoute = () =>{
    //    const navigate = useNavigate();
    //    const location = useLocation();
    //    if (
    //      !localStorage.getItem("Quizetoken") &&
    //      location.pathname !== "/quiz-game/login"
    //    ) {
    //      return <Navigate to="/quiz-game/login" />;
    //    } else if (
    //      !localStorage.getItem("Quizetoken") &&
    //      location.pathname === "/quiz-game/"
    //    ) {
    //      return <Navigate to="/" />;
    //    }
    //    return <Outlet />;
    // }

    // const PublicRoute = () => {
    //   if (localStorage.getItem("Quizetoken")) {
    //     return <Navigate to="/" />;
    //   }
    //   return <Outlet />;
    // };

    // const navigate = useNavigate();
    // let logoutTimer;

    // const resetTimer = () => {
    //   clearTimeout(logoutTimer);
    //   logoutTimer = setTimeout(() => {
    //     navigate("/logout"); // Or dispatch logout action, or clear auth token
    //   }, 900000); // 15 minutes
    // };

    // useEffect(() => {
    //   const events = ["click", "mousemove", "keypress", "scroll", "touchstart"];

    //   events.forEach((event) => {
    //     window.addEventListener(event, resetTimer);
    //   });

    //   resetTimer(); // start the timer

    //   return () => {
    //     events.forEach((event) => {
    //       window.removeEventListener(event, resetTimer);
    //     });
    //     clearTimeout(logoutTimer);
    //   };
    // }, []);


  return (
    <>
      {/* quiz-game */}
      <BrowserRouter basename="/">
        <InactivityHandler />
        <Routes>
          {/* Landing page no layout */}
          <Route path="/info" element={<LandingPage />} />
          <Route path="/sponsor-page/:name" element={<SponsorPage />} />
          <Route path="/triviafun" element={<Triviafun />} />
          <Route element={<MainRoutes />}>
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/gamearea" element={<GameArea />} />
            <Route path="/levelone" element={<LevelOne />} />
            <Route path="/leveltwo" element={<LevelTwo />} />
            <Route path="/resultpage" element={<ResultPage />} />
            <Route path="/gameoverpage" element={<GameoverPage />} />

            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termsconditions" element={<TermCondition />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/transaction-history" element={<Transact />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/leaderboard" element={<Leaderboader />} />
            <Route path="/demoresult" element={<Demoresult />} />
            <Route path="/demogame" element={<DemoGame />} />
            <Route path="/Leaderscore/:id" element={<LeaderScore />} />
            <Route path="/leaderboard/games" element={<GamesList />} />
            <Route path="/referral-link" element={<RefLink />} />
            <Route
              path="/free-game-leaderboard"
              element={<DemoLeaderboard />}
            />
            {/* </Route> */}

            {/* <Route element={<PublicRoute />}> */}
            <Route path="/instruction" element={<Instruction />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Homepage />} />
            {/* <Route path="/login" element={<Login />} /> */}
            <Route path="/forgot" element={<Forgot />} />
            <Route path="/verify-otp" element={<VerifyOTP />} />
            <Route path="/resetpassword" element={<Resetpassword />} />
          </Route>
        </Routes>{" "}
        {/* <Footer /> */}
      </BrowserRouter>
    </>
  );

  function InactivityHandler() {
    const navigate = useNavigate();
    const timerRef = useRef(null);

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        // Clear localStorage and redirect to login
        localStorage.removeItem("Quizetoken");
        localStorage.removeItem("UserIdclient");
        localStorage.removeItem("UserIdMongo");
        localStorage.removeItem("GameId");
        localStorage.removeItem("userName");
        localStorage.removeItem("wallet");
        localStorage.removeItem("demoresult");
        localStorage.removeItem("resultPath");
        navigate("/login");
      }, 3600000); // 1hr
    };

    useEffect(() => {
      const events = ["click", "mousemove", "keypress", "scroll", "touchstart"];
      events.forEach((event) => window.addEventListener(event, resetTimer));

      resetTimer(); // Start on load

      return () => {
        events.forEach((event) =>
          window.removeEventListener(event, resetTimer)
        );
        clearTimeout(timerRef.current);
      };
    }, []);

    return null; // Doesn't render anything
  }
}

export default Router;

        // <div className="layout has-sidebar fixed-sidebar fixed-header">
        //   <Sidenavar />
        //   <div className="layout">
        //     <main className="content">
        //       <Header />
        //       <Routes>
        //         {/* <Route element={<ProtectedRoute />}> */}
        //         <Route path="/profile" element={<ProfilePage />} />
        //         <Route path="/gamearea" element={<GameArea />} />
        //         <Route path="/levelone" element={<LevelOne />} />
        //         <Route path="/leveltwo" element={<LevelTwo />} />
        //         <Route path="/resultpage" element={<ResultPage />} />
        //         <Route path="/gameoverpage" element={<GameoverPage />} />

        //         <Route path="/privacy" element={<Privacy />} />
        //         <Route path="/termsconditions" element={<TermCondition />} />
        //         <Route path="/wallet" element={<Wallet />} />
        //         <Route path="/transaction-history" element={<Transact />} />
        //         <Route path="/leaderboard" element={<Leaderboader />} />
        //         <Route path="/demoresult" element={<Demoresult />} />
        //         <Route path="/demogame" element={<DemoGame />} />
        //         <Route path="/Leaderscore/:id" element={<LeaderScore />} />
        //         <Route path="/leaderboard/games" element={<GamesList />} />
        //         <Route path="/referral-link" element={<RefLink />} />
        //         <Route
        //           path="/free-game-leaderboard"
        //           element={<DemoLeaderboard />}
        //         />
        //         {/* </Route> */}

        //         {/* <Route element={<PublicRoute />}> */}
        //         <Route path="/instruction" element={<Instruction />} />
        //         <Route path="/login" element={<Login />} />
        //         <Route path="/" element={<Homepage />} />
        //         {/* <Route path="/login" element={<Login />} /> */}
        //         <Route path="/forgot" element={<Forgot />} />
        //         <Route path="/verify-otp" element={<VerifyOTP />} />
        //         <Route path="/resetpassword" element={<Resetpassword />} />
        //         {/* </Route> */}
        //       </Routes>
        //     </main>
        //   </div>
        // </div>
        // <Routes></Routes>